import { render, staticRenderFns } from "./RiesgoCaidas.vue?vue&type=template&id=797ea04f"
import script from "./RiesgoCaidas.vue?vue&type=script&lang=js"
export * from "./RiesgoCaidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports